export default __webpack_public_path__ + "static/media/slider_5.affc6ca9.jpg";